import * as React from "react";
export default class TypeFilter extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        let typeSelected = this.props.typeSelected;
        return (React.createElement("nav", { className: "type-filter", style: { display: this.props.categoryTypes.length > 1 ? 'flex' : 'none' } },
            React.createElement("div", { className: typeSelected === "" ? "active" : "", onClick: () => { this.props.changeTypes(""); } }, "All"),
            this.props.categoryTypes.map((cType, index) => {
                return React.createElement("div", { key: index, className: typeSelected === cType ? "active" : "", onClick: () => { this.props.changeTypes(cType); } }, cType);
            })));
    }
}
;
//# sourceMappingURL=type-filter.js.map